import React from "react";

import { toast } from "sonner";
import { ActionNode } from "../../../../views/convoauto-pages/bot-studio/types";
import { CardShell, MediaUploadWidget } from "./card-handler";
import { TemplateModule } from "../../../../views/marketing-pages/templates";

type MediaUploadRequest = (data: FormData) => Promise<any[]>;

interface SendMessageCardProps {
  node: ActionNode;
  onUpdate: (config: Record<string, any>) => void;
  onDelete: () => void;
  onReset: () => void;
  mediaUpload?: MediaUploadRequest;
  templates?: TemplateModule[];
  bare?: boolean;
}

export const SendMessageCard: React.FC<SendMessageCardProps> = ({
  node,
  onUpdate,
  onDelete,
  onReset,
  mediaUpload,
  bare,
}) => {
  const extractMediaUrl = (response: any) =>
    response?.uploaded_files?.[0]?.preview_url ??
    response?.uploaded_files?.[0]?.url ??
    response?.uploaded_files?.[0]?.file_url ??
    response?.data?.uploaded_files?.[0]?.preview_url ??
    response?.data?.uploaded_files?.[0]?.url ??
    response?.data?.url ??
    response?.data?.media_url ??
    response?.url ??
    response?.media_url ??
    response?.file_url;

  const handleUploaded = async (file: File, type: any) => {
    if (!mediaUpload) {
      toast.error("Media upload is not configured.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const [response, status = 500] = await mediaUpload(formData);
    const mediaUrl = extractMediaUrl(response);

    if (status >= 400 || !mediaUrl) {
      toast.error(response?.message || response?.detail || "Failed to upload media.");
      return;
    }

    onUpdate({
      ...node.config,
      media_url: mediaUrl,
      media_type: type,
    });
    toast.success("Media uploaded successfully.");
  };

  const handleRemoveMedia = () => {
    onUpdate({ ...node.config, media_url: null, media_type: null });
  };

  return (
    <CardShell title="Send WhatsApp Message" onDelete={onDelete} onReset={onReset} bare={bare}>
      <MediaUploadWidget
        mediaUrl={node.config?.media_url ?? null}
        mediaType={node.config?.media_type ?? null}
        onUploaded={handleUploaded}
        onRemove={handleRemoveMedia}
      />

      <p className="text-xs text-gray-500 dark:text-gray-400 mb-1.5">Message Body</p>
      <textarea
        className="w-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-transparent text-gray-700 dark:text-gray-300 placeholder-gray-400 dark:placeholder-gray-500 outline-none focus:ring-1 focus:ring-indigo-300 resize-none rounded-lg px-3 py-2 text-sm"
        placeholder="Write your message. . ."
        rows={3}
        value={node.config?.message ?? ""}
        onChange={(e) => onUpdate({ ...node.config, message: e.target.value })}
      />
    </CardShell>
  );
};